export default {
  'enabled-locations-map': {
    locations: 'Locais',
    'find-my-location': 'Encontrar meu local',
    'select-country': 'Selecionar país',
    'all-countries': 'Todos os países',
    search: 'Buscar',
    filter: 'Filtrar por provedor, cidade, país ou estado',
    'location-type': 'Tipo de local',
    '100G-enabled': 'Compatível com 100G',
    'local-ix-available': 'IX local disponível',
    'mcr-enabled': 'Compatível com MCR',
    'mve-enabled': 'Compatível com MVE',
    'view-latency': 'Ver latência',
    'enquire-about-this-location': 'Solicitar informações sobre este local',
    'enabled-location': 'Local habilitado',
    'extended-location': 'Local expandido',
    'loading-locations': 'Carregando locais',
    'no-location-found': 'Nenhum local atende aos critérios do filtro',
    'closest-mp-enabled-location': 'O local habilitado da Megaport mais próximo é',
    'location-filter': 'Filtro de local',
    'coming-soon': 'Em breve',
    'enter-your-address': 'Insira seu endereço',
    'learn-about-enabled-extended-locations': 'Saiba mais sobre nossos Locais Habilitados e Estendidos',
    'megaport-supported-location-types': 'A Megaport suporta dois tipos de locais onde você pode acessar nossa rede',
    'locations-by-distance': 'Locais por distância',
    'map-showing-data-center-location': 'Mapa mostrando a localização do data center',
  },
}
  
